import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SportsSoccerIcon(props: IconProps) {
    return <Icon {...props} iconKey={"sports_soccer"}/>
}
